import { Offer, TranslationFunction } from './types';
import { Tooltip, Typography } from 'antd';
const { Text } = Typography;
const heart = require('../../../../assets/icons/heart.png');
const house = require('../../../../assets/icons/house.png');
const pensionPlan = require('../../../../assets/icons/pension_plan.png');
const unemployment = require('../../../../assets/icons/unemployment.png');
const car = require('../../../../assets/icons/car.png');
const creditCard = require('../../../../assets/icons/credit_card.png');
const payroll = require('../../../../assets/icons/payroll.png');
const bills = require('../../../../assets/icons/bills.png');
const accidents = require('../../../../assets/icons/accidents_icon.png');
const investmentFund = require('../../../../assets/icons/investment_fund.png');
const energetic = require('../../../../assets/icons/energetic_rating.png');
const paymentsSecure = require('../../../../assets/icons/payments.png');

//Funciones para Card y Tabla de ofertas
export const selectImagebank = (offer: Offer, table: boolean) => (
	<img
		src={
			'https://gibobs-prod-cdn.s3.eu-central-1.amazonaws.com/images/banks/' +
			`${offer.bankCode}` +
			'.png'
		}
		alt={offer.bankName}
		style={{ height: table ? 28 : 32, width: 'auto' }}
	/>
);

export const selectLogoBank = (offer: Offer) => (
	<img
		src={
			'https://gibobs-prod-cdn.s3.eu-central-1.amazonaws.com/images/banks/' +
			`${offer.bankCode}` +
			'_iso.png'
		}
		alt={offer.bankName}
		style={{ height: 24 }}
	/>
);

export const capitalizeFirstLetter = (type: string) => {
	return type.charAt(0).toUpperCase() + type.slice(1);
};

export const renderType = (offer: Offer, t: TranslationFunction) => {
	if (offer.ratio === 'FIXED') {
		return capitalizeFirstLetter(t('viabilityNew.fixed'));
	} else if (offer.ratio === 'MIXED') {
		return capitalizeFirstLetter(t('loan.mixedOnboarding'));
	} else {
		return capitalizeFirstLetter(t('cards.variable'));
	}
};

export const getLinkages = (offer: Offer, t: TranslationFunction, table: boolean) => {
	const field = [];
	if (offer.data !== undefined) {
		const [entailment] = offer.data.entailments;
		if (entailment?.linkages !== undefined) {
			if (entailment.linkages.insecurance.isChecked !== false) {
				field.push(
					<Tooltip
						placement="bottom"
						title={
							<div style={{ display: 'flex', flexDirection: 'column' }}>
								<div>{t('loan.entailments_insecurance')}</div>
								<div>{entailment.linkages.insecurance.amount + '%'}</div>
							</div>
						}>
						<img src={heart} alt="heart" width={20} height={20} />
					</Tooltip>
				);
			}
			if (entailment.linkages.car.isChecked !== false) {
				field.push(
					<Tooltip
						placement="bottom"
						title={
							<div style={{ display: 'flex', flexDirection: 'column' }}>
								<div>{t('loan.entailments_car')}</div>
								<div>{entailment.linkages.car.amount + '%'}</div>
							</div>
						}>
						<img src={car} alt="car" width={22} height={22} />
					</Tooltip>
				);
			}

			if (entailment.linkages.payroll.isChecked !== false) {
				field.push(
					<Tooltip
						placement="bottom"
						title={
							<div style={{ display: 'flex', flexDirection: 'column' }}>
								<div>{t('loan.entailments_payroll')}</div>
								<div>{entailment.linkages.payroll.amount + '%'}</div>
							</div>
						}>
						<img src={payroll} alt="payroll" width={18} height={18} />
					</Tooltip>
				);
			}
			if (entailment.linkages.unemployment.isChecked !== false) {
				field.push(
					<Tooltip
						placement="bottom"
						title={
							<div style={{ display: 'flex', flexDirection: 'column' }}>
								<div>{t('loan.entailments_unemployment')}</div>
								<div>{entailment.linkages.unemployment.amount + '%'}</div>
							</div>
						}>
						<img src={unemployment} alt="unemployment" width={20} height={20} />
					</Tooltip>
				);
			}
			if (entailment.linkages.home.isChecked !== false) {
				field.push(
					<Tooltip
						placement="bottom"
						title={
							<div style={{ display: 'flex', flexDirection: 'column' }}>
								<div>{t('loan.entailments_home')}</div>
								<div>{entailment.linkages.home.amount + '%'}</div>
							</div>
						}>
						<img src={house} alt="home" width={'auto'} height={22} />
					</Tooltip>
				);
			}
			if (entailment.linkages.payments.isChecked !== false) {
				field.push(
					<Tooltip
						placement="bottom"
						title={
							<div style={{ display: 'flex', flexDirection: 'column' }}>
								<div>{t('loan.entailments_bills')}</div>
								<div>{entailment.linkages.payments.amount + '%'}</div>
							</div>
						}>
						<img src={bills} alt="bills" width={'auto'} height={22} />
					</Tooltip>
				);
			}
			if (entailment.linkages.pensionPlan.isChecked !== false) {
				field.push(
					<Tooltip
						placement="bottom"
						title={
							<div style={{ display: 'flex', flexDirection: 'column' }}>
								<div>{t('loan.entailments_pensionPlan')}</div>
								<div>{entailment.linkages.pensionPlan.amount + '%'}</div>
							</div>
						}>
						<img src={pensionPlan} alt="pension" width={'auto'} height={22} />
					</Tooltip>
				);
			}
			if (entailment.linkages.cards.isChecked !== false) {
				field.push(
					<Tooltip
						placement="bottom"
						title={
							<div style={{ display: 'flex', flexDirection: 'column' }}>
								<div>{t('loan.entailments_cards')}</div>
								<div>{entailment.linkages.cards.amount + '%'}</div>
							</div>
						}>
						<img src={creditCard} alt="card" width={'auto'} height={22} />
					</Tooltip>
				);
			}
			if (entailment.linkages.accidents.isChecked !== false) {
				field.push(
					<Tooltip
						placement="bottom"
						title={
							<div style={{ display: 'flex', flexDirection: 'column' }}>
								<div>{t('loan.entailments_accidentInsurance')}</div>
								<div>{entailment.linkages.accidents.amount + '%'}</div>
							</div>
						}>
						<img width={'auto'} height={22} src={accidents} alt="" />{' '}
					</Tooltip>
				);
			}
			if (entailment.linkages.investmentFunds.isChecked !== false) {
				field.push(
					<Tooltip
						placement="bottom"
						title={
							<div style={{ display: 'flex', flexDirection: 'column' }}>
								<div>{t('loan.entailments_investmentFund')}</div>
								<div>{entailment.linkages.investmentFunds.amount + '%'}</div>
							</div>
						}>
						<img src={investmentFund} alt="investment" width={'auto'} height={22} />
					</Tooltip>
				);
			}
			if (entailment.linkages.energyCertification.isChecked !== false) {
				field.push(
					<Tooltip
						placement="bottom"
						title={
							<div style={{ display: 'flex', flexDirection: 'column' }}>
								<div>{t('loan.entailments_energyRating')}</div>
								<div>{entailment.linkages.energyCertification.amount + '%'}</div>
							</div>
						}>
						<img src={energetic} alt="energetic" width={'auto'} height={22} />
					</Tooltip>
				);
			}
			if (entailment.linkages.protectedPayments.isChecked !== false) {
				field.push(
					<Tooltip
						placement="bottom"
						title={
							<div style={{ display: 'flex', flexDirection: 'column' }}>
								<div>{t('icon.viability2')}</div>
								<div>{entailment.linkages.protectedPayments.amount + '%'}</div>
							</div>
						}>
						<img src={paymentsSecure} alt="payments" width={'auto'} height={22} />
					</Tooltip>
				);
			}
		}
		if (!field.length) {
			if (table) {
				return (
					<Text style={{ fontSize: 14, fontWeight: 600, color: '#262626', display: 'block' }}>
						-
					</Text>
				);
			} else {
				return (
					<Text style={{ fontSize: 14, fontWeight: 600, color: '#262626', display: 'block' }}>
						{t('offers.linkages')}
					</Text>
				);
			}
		}
	}
	return field;
};

export const renderAmortization = (revision: string, t: TranslationFunction) => {
	if (revision === 'LAW') {
		return t('offer.law');
	} else if (revision === 'ZERO') {
		return '0%';
	} else {
		return t('loan.noBankAvatar');
	}
};

export const renderRevision = (revision: string, t: TranslationFunction) => {
	if (revision === 'BIANNUAL') {
		return t('offer.biannual');
	} else {
		return t('loan.annual');
	}
};

export const showHeart = (favoriteOffers: Offer[], offer: Offer) => {
	return (
		!favoriteOffers.some((fav: Offer) => fav.bankCode === offer.bankCode) ||
		!favoriteOffers.some(
			(fav: Offer) =>
				fav.bankCode === offer.bankCode && offer.bankRequest.type === 'API' && fav.isFavorite
		)
	);
};

export const hasLinkages = (offer: Offer) => {
	const linkages = offer?.data?.entailments[0]?.linkages;
	if (!linkages) {
		return false;
	}
	for (const key in linkages) {
		if (linkages.hasOwnProperty(key) && linkages[key].isChecked) {
			return true;
		}
	}
	return false;
};
